import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
var isValueEmpty = function isValueEmpty(value) {
  return value === undefined || value === null;
};
var DropdownNative = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropdownNative, _React$PureComponent);
  var _super = _createSuper(DropdownNative);
  function DropdownNative() {
    var _this;
    _classCallCheck(this, DropdownNative);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (index) {
      var value = _this.props.value;
      var selectedValue = index.target.value;
      if (!(isValueEmpty(value) && selectedValue === null || value === selectedValue)) {
        _this.props.onChange(selectedValue);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      return _this.select.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
        wide = _this$props.wide,
        placeholder = _this$props.placeholder,
        name = _this$props.name,
        disabled = _this$props.disabled,
        className = _this$props.className,
        size = _this$props.size,
        status = _this$props.status;
      var classes = cx({
        wide: wide,
        default: isValueEmpty(_this.props.value)
      }, className, "".concat(size, "Size"), 'native', status);
      return /*#__PURE__*/React.createElement("select", {
        className: classes,
        disabled: disabled,
        name: name,
        onChange: _this.handleChange,
        ref: function ref(e) {
          _this.select = e;
        },
        value: isValueEmpty(_this.props.value) ? '' : _this.props.value,
        "data-t-id": "Dropdown-components"
      }, isValueEmpty(_this.props.value) && /*#__PURE__*/React.createElement("option", {
        value: ""
      }, placeholder), _this.props.options.map(function (_ref) {
        var label = _ref.label,
          value = _ref.value;
        return /*#__PURE__*/React.createElement("option", {
          key: "".concat(label, "_").concat(value),
          value: value
        }, label);
      }));
    });
    return _this;
  }
  return _createClass(DropdownNative);
}(React.PureComponent);
_defineProperty(DropdownNative, "defaultProps", {
  placeholder: 'Выберите значение',
  size: 'default',
  name: null,
  wide: false,
  className: null,
  disabled: false
});
export { DropdownNative as default };
DropdownNative.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string
  })).isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  wide: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big']),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
} : {};